export enum InfoMenuEnum {
    CONTACTS = 'contacts',
    IMPRESSUM = 'impressum',
    FAQS = 'faqs',
    PRIVACY_POLICY = 'privacyPolicy',
    SUPPORT = 'support',
    TERMS_OF_USE = 'termsOfUse',
}
